import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForward = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "forward",
	"data-name": "forward",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 12,
			cy: 12,
			r: 10.5
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "plan2plate-icon",
			points: "14.86 12 8.18 15.82 8.18 8.18 14.86 12"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 15.82,
			y1: 7.23,
			x2: 15.82,
			y2: 16.77
		})
	]
});
const ForwardRef = forwardRef(SvgForward);
export default ForwardRef;
